var isUndefined = function isUndefined(value) {
  return value === undefined;
};

module.exports = isUndefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-undefined.js
// module id = 417
// module chunks = 0